import { useRef, useCallback } from 'react'

export const useControlBarFocus = () => {
  const controlBarFocusRef = useRef<HTMLDivElement | null>(null)

  const handleFocusControlBar = useCallback(() => {
    const firstButton = controlBarFocusRef.current?.querySelector('button')
    firstButton?.focus()
  }, [])

  return { controlBarFocusRef, handleFocusControlBar }
}
